<template>
  <b-card
      border-variant="secondary"
      align="center"
      style="max-width: 50rem;"
      class="mx-auto"
      no-body>
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block v-b-toggle.unitInfoCollapse variant="secondary">{{ $t('nav.unitWifi') }}</b-button>
    </b-card-header>
    <b-collapse id="unitInfoCollapse" visible >
      <b-card-body >
        <b-row  class="justify-content-sm-center border-bottom border-light">
          <UnitSecret class="mt-0 mb-2 text-center" :label="$t('unitInfo.secret')"
                    showChange=true  :secret="this.$store.getters.getUnitSecret" secretType="UNIT"/>
        </b-row>
        <UnitDevices class="mt-2 text-center" type="UNIT" :caption="$t('unitInfo.deviceCaption')"/>

      </b-card-body>
    </b-collapse>
  </b-card>
</template>


<script>

import store from "../store/store";
import UnitDevices from "@/components/UnitDevicesTable";
import UnitSecret from "@/components/UnitSecret";
export default {
  name: 'UnitInfo',
  components: {
    UnitDevices,
    UnitSecret
  },
  async mounted () {
    await store.dispatch("loadUnitInformationFromApi")
    await store.dispatch("loadPropertyInfo")
  },
  methods: {
  }
}
</script>